import React, { FC, ReactNode } from "react";
import { IconTypesKeys } from "@evergis/ui";

import { AddAttribute, AddAttributeIconButton } from "../../NewLayer/styled";

type AddAttributeButtonProps = {
  className?: string;
  children: ReactNode;
  onClick: VoidFunction;
  disabled?: boolean;
  icon?: IconTypesKeys;
  innerRef?: (node: HTMLButtonElement | null) => void;
};

export const AddAttributeButton: FC<AddAttributeButtonProps> = ({
  className,
  children,
  onClick,
  disabled,
  icon = "feature_add",
  innerRef,
}) => (
  <AddAttribute className={className}>
    <AddAttributeIconButton innerRef={innerRef} kind={icon} onClick={onClick} disabled={disabled}>
      {children}
    </AddAttributeIconButton>
  </AddAttribute>
);
